import { moment } from "#src/utils/dateTime.ts";
import { useState } from "react";

export function getCurrentDate() {
  return new Date();
}

export function useCurrentDate() {
  const [currentDate] = useState(getCurrentDate);

  return currentDate;
}

export function getCurrentTimestamp() {
  return moment().valueOf();
}

/**
 * Stable "now" for render-time `moment()` usage. Returns a timestamp rather
 * than a moment instance so each call site can build its own (mutable) moment
 * via `moment(currentTimestamp)` without sharing a single object.
 */
export function useCurrentTimestamp() {
  const [currentTimestamp] = useState(getCurrentTimestamp);

  return currentTimestamp;
}
